var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"image-preview",style:({
    transform: ("scale(" + (_vm.props.zoom) + ") rotate(" + (_vm.props.rotate) + "deg)"),
  }),attrs:{"src":_vm.props.src}})}
var staticRenderFns = []

export { render, staticRenderFns }